export default "__VITE_ASSET__CONsj7Wr__"